// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumb {
  display: flex;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 10px 0;
  line-height: 1.2;
  color: var(--sebrae-light-gray2);
  gap: 4px;
}
.breadcrumb .item {
  display: flex;
  align-items: center;
  gap: 4px;
  color: inherit;
  font-size: 13px;
}
.breadcrumb .item a {
  color: inherit;
  font: inherit;
}
.breadcrumb .item svg {
  color: inherit;
}
.breadcrumb .item:last-of-type {
  font-weight: 700;
  color: var(--sebrae-blue);
}
.breadcrumb.desktop {
  display: none;
}
@media screen and (min-width: 768px) {
  .breadcrumb.mobile {
    display: none;
  }
  .breadcrumb.desktop {
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/breadcrumb/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,gBAAA;EACA,gCAAA;EACA,QAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,eAAA;AACJ;AACI;EACE,cAAA;EACA,aAAA;AACN;AACI;EACE,cAAA;AACN;AAEI;EACE,gBAAA;EACA,yBAAA;AAAN;AAGE;EACE,aAAA;AADJ;AAIE;EACE;IACE,aAAA;EAFJ;EAIE;IACE,aAAA;EAFJ;AACF","sourcesContent":[".breadcrumb {\n  display: flex;\n  align-items: center;\n  list-style: none;\n  padding: 0;\n  margin: 10px 0;\n  line-height: 1.2;\n  color: var(--sebrae-light-gray2);\n  gap: 4px;\n\n  .item {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    color: inherit;\n    font-size: 13px;\n\n    a {\n      color: inherit;\n      font: inherit;\n    }\n    svg {\n      color: inherit;\n    }\n\n    &:last-of-type {\n      font-weight: 700;\n      color: var(--sebrae-blue);\n    }\n  }\n  &.desktop {\n    display: none;\n  }\n\n  @media screen and (min-width: 768px){\n    &.mobile {\n      display: none;\n    }\n    &.desktop {\n      display: flex;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
